import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const TermsOfService = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Last Updated: 28th March 2025
        </Typography>

        <Typography variant="body1" paragraph>
          Welcome to Smyan Tech Solutions Pvt Ltd (herein referred as “dequitec”, "we," "us," or "our").
          These Terms of Service ("Terms") govern your access to and use of our website, www.dequitec.in (the "Site"),
          and the services we provide, including business loan aggregation, credit analysis report downloads, one-pager
          generation, and CMA Data/financial projection tools (collectively, the "Services"). By accessing or using the
          Site and Services, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you
          must not use the Site or Services.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" gutterBottom>
          1. Acceptance of Terms
        </Typography>
        <Typography variant="body1" paragraph>
          By using the Site and Services, you represent that you are at least 18 years old and have the legal capacity
          to enter into these Terms. If you are using the Services on behalf of a business, you represent that you have
          the authority to bind that business to these Terms.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          2. Description of Services
        </Typography>
        <Typography variant="body1">
          Our Services include:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              <strong>Business Loan Aggregation:</strong> Connecting you with Lenders who may offer business loan
              options based on the information you provide.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Credit Analysis Downloads:</strong> Providing access to your business and/or personal credit
              analysis reports derived from third-party data.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>One-Pager Generation:</strong> Offering tools to generate a concise summary of your business's
              key financial and operational information.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Financial Projection Tools:</strong> Offering tools to assist you in creating financial
              projections for your business.
            </Typography>
          </li>
        </ul>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          3. User Accounts
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              To access certain features of the Services, you may be required to create an account. You are responsible
              for maintaining the confidentiality of your account credentials and for all activities that occur under
              your account.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              You agree to provide accurate and complete information when creating your account and using the Services.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              We reserve the right to suspend or terminate your account if we believe you have violated these Terms.
            </Typography>
          </li>
        </ul>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          4. Credit Analysis, One-Pagers, and Financial Projections
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              <strong>Credit Analysis:</strong> Reports are derived from third-party data and may have limitations. We
              do not guarantee accuracy.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>One-Pagers:</strong> Generated based on the information you provide. Accuracy is your
              responsibility.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Financial Projections:</strong> Provided for informational purposes only and should not be
              considered financial advice.
            </Typography>
          </li>
        </ul>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          5. Loan Aggregation and Lender Interactions
        </Typography>
        <Typography variant="body1" paragraph>
          We act as an intermediary between you and Lenders. We do not guarantee that you will be approved for a loan.
          Loan offers are subject to the terms and conditions of the Lenders.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          6. User Content
        </Typography>
        <Typography variant="body1">
          You are responsible for any information, data, or content you provide through the Services.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          7. Intellectual Property
        </Typography>
        <Typography variant="body1">
          The Site and Services, including all content, software, and trademarks, are owned by us or our licensors and
          are protected by intellectual property laws.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          8. Disclaimer of Warranties
        </Typography>
        <Typography variant="body1">
          The Services are provided "as is" without warranties of any kind, whether express or implied.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          9. Limitation of Liability
        </Typography>
        <Typography variant="body1">
          We shall not be liable for any indirect, incidental, consequential, or punitive damages arising from your use
          of the Services.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          10. Indemnification
        </Typography>
        <Typography variant="body1">
          You agree to indemnify and hold us harmless from any claims, damages, or expenses arising from your use of the
          Services or your violation of these Terms.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          11. Termination
        </Typography>
        <Typography variant="body1">
          We may terminate your access to the Services at any time, with or without cause.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          12. Governing Law and Dispute Resolution
        </Typography>
        <Typography variant="body1">
          These Terms shall be governed by the laws of India, with disputes resolved in Delhi courts.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          13. Changes to these Terms
        </Typography>
        <Typography variant="body1">
          We may update these Terms periodically. Your continued use of the Services after updates constitutes your
          acceptance.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h5" gutterBottom>
          14. Contact Us
        </Typography>
        <Typography variant="body1">
          Smyan Tech Solutions Pvt Ltd, Bldg No. 145, Sector 44, Gurgaon, Haryana – 122003;
          contact@dequitec.com
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService;
